export default __webpack_public_path__ + "static/pixel-0667cb48165d6a383f1367e8a5ff8d06.jpg";